import { format } from "date-fns";

export const toShortISO = (date: Date) => {
  return format(date, "yyyy-MM-dd");
};

export const toLongIso = (date: Date) => {
  return format(date, "yyyy-MM-dd HH:mm");
};
